import { IonCheckbox, IonInput } from "@ionic/react";
import React, { useEffect, useState, useRef } from "react";
import { useRecoilState } from "recoil";
import { IseditingLookupsState, newAllDropDownState } from "../data/atoms";
import { Option } from "../models/Option";

interface Props {
  isEdit: boolean;
  placeholder: string;
  isSearchable: boolean;
  isEditableOption: boolean;
  allOptions: any;
  value: any;
  LookUpType: any;
  onSelectOption: Function;
  onAddOrEditLookUp: Function;
  isMultiSelect: boolean;
  selectedTags?: any[];
}
const SelectSectionCustom: React.FC<Props> = ({
  isEdit,
  placeholder,
  isSearchable,
  isEditableOption,
  allOptions,
  value,
  LookUpType,
  onSelectOption,
  onAddOrEditLookUp,
  isMultiSelect,
  selectedTags,
}) => {
  const [optionList, setOptionList] = useState(allOptions);
  const [selectedValue, setSelectedValue] = useState(value != "" ? value : "");
  const [tagName, setTagName] = useState<String>("");
  const [isDropDown, setIsDropDown] = useState<boolean>(false);
  const elementRef = useRef(null);
  const [iseditingLookup, setIseditingLookup] = useRecoilState(
    IseditingLookupsState,
  );
  const [newAllDropDown, setNewAllDropDown] =
    useRecoilState(newAllDropDownState);

  useEffect(() => {
    setOptionList(allOptions);
    setTagName(LookUpType);
    setDefaultSelectedValue();
  }, [allOptions || selectedValue]);

  useOnClickOutside(elementRef, () =>
    LookUpType != "Setting"
      ? setTimeout(() => {
          setIsDropDown(false);
        }, 200)
      : setIsDropDown(isDropDown),
  );

  function useOnClickOutside(elementRef: any, handler: any) {
    useEffect(() => {
      const listener = (event: any) => {
        if (!elementRef.current || elementRef.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    }, [elementRef, handler]);
  }

  const setDefaultSelectedValue = () => {
    if (
      LookUpType &&
      !(tagName == "Tags" || tagName == "Diagnosis" || tagName == "Medications")
    ) {
      let data: any = getSelectedOption(LookUpType);
      if (data !== undefined && data !== null) {
        if (isEdit || iseditingLookup.IseditingLookups) {
          setSelectedValue(data?.value);
        }
      }
    }
  };

  function getSelectedOption(type: any) {
    debugger;
    let opt;
    if (type == "Setting") {
      // return getSelectedOption1( newAllDropDown.SettingOpt, patientDetails.patientSetting)
      opt =
        newAllDropDown.setting?.id != null &&
        newAllDropDown.setting.id != undefined &&
        newAllDropDown.setting.id != 6
          ? {
              id: newAllDropDown.setting.id,
              value: newAllDropDown.setting.name,
              label: newAllDropDown.setting.name,
            }
          : null;
      return opt;
    } else if (type == "Department") {
      // return getSelectedOption1( newAllDropDown.DepartmentOpt, patientDetails.departmentId)
      opt =
        newAllDropDown.department?.id != null &&
        newAllDropDown.department.id != undefined
          ? {
              id: newAllDropDown.department.id,
              value: newAllDropDown.department.name,
              label: newAllDropDown.department.name,
            }
          : null;
      return opt;
    } else if (type == "Physician") {
      // return getSelectedOption1( newAllDropDown.PhysicianOpt, patientDetails.physicianId)
      opt =
        newAllDropDown.physician?.id != null &&
        newAllDropDown.physician.id != undefined
          ? {
              id: newAllDropDown.physician.id,
              value: newAllDropDown.physician.name,
              label: newAllDropDown.physician.name,
            }
          : null;
      return opt;
    } else if (type === "Referral") {
      // return getSelectedOption1( newAllDropDown.ReferralOpt, patientDetails.referralId)
      opt =
        newAllDropDown.referral?.id != null &&
        newAllDropDown.referral.id != undefined
          ? {
              id: newAllDropDown.referral.id,
              value: newAllDropDown.referral.name,
              label: newAllDropDown.referral.name,
            }
          : null;
      return opt;
    } else if (type === "FollowUpType") {
      opt =
        newAllDropDown.followUpType?.id != null &&
        newAllDropDown.followUpType.id != undefined
          ? {
              id: newAllDropDown.followUpType.id,
              value: newAllDropDown.followUpType.name,
              label: newAllDropDown.followUpType.name,
            }
          : null;
      return opt;
    } else if (type === "Tags") {
      // opt = newAllDropDown.tags != null && newAllDropDown.tags != undefined && newAllDropDown.tags.length != 0 ? {id: newAllDropDown.tags[0].id, value: newAllDropDown.tags[0].name, label: newAllDropDown.tags[0].name} : null;
      // return opt
    } else if (type === "Diagnosis") {
      // opt = newAllDropDown.Diagnosis != null && newAllDropDown.Diagnosis != undefined && newAllDropDown.Diagnosis.length != 0 ? ConvertToOptions(newAllDropDown.Diagnosis) : null;
      // return opt
    } else if (type === "Role") {
      opt =
        newAllDropDown.role?.id != null && newAllDropDown.role.id != undefined
          ? {
              id: newAllDropDown.role.id,
              value: newAllDropDown.role.name,
              label: newAllDropDown.role.name,
            }
          : null;
      return opt;
    }
  }

  const setSelectOption = (obj: any, type: any) => {
    onSelectOption(obj, type);
  };

  const handleSelection = (option: any, tagName: any) => {
    !(
      tagName === "Tags" ||
      tagName === "Diagnosis" ||
      tagName === "Medications"
    ) && setSelectedValue(option.name);

    setSelectOption(option, tagName);

    if (
      tagName === "Setting" ||
      tagName === "Physician" ||
      tagName === "Referral" ||
      tagName === "Department" ||
      tagName === "FollowUpType"
    ) {
      setIsDropDown(false);
    }

    tagName === "Setting" && setSelectOption(option, tagName);
    tagName === "VisitType" && setSelectOption(option, tagName);
  };

  const searchInList = (e: any) => {
    if (isSearchable) {
      if (e.target.value !== "") {
        let optionSearched = allOptions.filter((option: any) => {
          if (
            option.name.toLowerCase().startsWith(e.target.value.toLowerCase())
          ) {
            return option;
          }
        });
        setOptionList([...optionSearched]);

        setSelectedValue(e.target.value);
      } else {
        setSelectedValue("");
        setOptionList([...allOptions]);
      }
    }
  };

  return (
    <>
      {/* select-search select-opened */}
      <div
        ref={elementRef}
        className={`select-wrap-sec  ${
          isSearchable && LookUpType !== "Setting" ? "select-search" : ""
        }`}
      >
        {isSearchable ? (
          <IonInput
            className="input-field"
            type="text"
            readonly={!isSearchable}
            placeholder={placeholder}
            value={selectedValue}
            onIonChange={(e) => {
              searchInList(e);
            }}
            onClick={() => {
              setIsDropDown(!isDropDown);
            }}
          ></IonInput>
        ) : (
          <div
            className="input-field"
            onClick={() => {
              setIsDropDown(!isDropDown);
            }}
          >
            {selectedValue ? selectedValue : placeholder}
          </div>
        )}

        {isDropDown && (
          <>
            <div
              className={`select-option-wrap  ${
                LookUpType == "Setting" && "setting-dropdown"
              } ${isDropDown && "selected"}`}
            >
              {isEditableOption && (
                <h2
                  onClick={() => {
                    onAddOrEditLookUp(false, -1, "", tagName);
                  }}
                >
                  + Add "New{" "}
                  {tagName
                    ? tagName.charAt(0).toUpperCase() +
                      (tagName == "Tags"
                        ? tagName.slice(1, -1)
                        : tagName.slice(1))
                    : ""}
                  "
                </h2>
              )}
              <ul>
                {optionList && optionList.length > 0 ? (
                  optionList.map((option: Option) => {
                    return (
                      <li className="option-wrapper" key={option.id}>
                        {isMultiSelect && (
                          <>
                            {/* <input
                              type="checkbox"
                              className="input-checkbox"
                              onClick={() => {
                                handleSelection(option, tagName);
                              }}
                              defaultChecked={selectedTags?.some(
                                (tag: Option) => tag.id === option.id
                              )}
                            /> */}
                          </>
                        )}
                        <div
                          className="option-name"
                          onClick={() => {
                            handleSelection(option, tagName);
                          }}
                          key={option.id}
                        >
                          {isMultiSelect && (
                            <IonCheckbox
                              className="reactangle-checkbox"
                              placeholder={undefined}
                              onClick={() => {
                                handleSelection(option, tagName);
                              }}
                              checked={selectedTags?.some(
                                (tag: Option) => tag.id === option.id,
                              )}
                            ></IonCheckbox>
                          )}
                          <span>{option.name}</span>
                        </div>
                        {isEditableOption && !option.isDefault && (
                          <div
                            className="option-edit-icon"
                            onClick={() => {
                              onAddOrEditLookUp(
                                true,
                                option.id,
                                option.name,
                                tagName,
                              );
                            }}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.30984 14.0002V14.5002C8.44245 14.5002 8.56962 14.4475 8.66339 14.3537L8.30984 14.0002ZM6 14.0002H5.5C5.5 14.2763 5.72386 14.5002 6 14.5002V14.0002ZM6 11.6903L5.64645 11.3368C5.55268 11.4305 5.5 11.5577 5.5 11.6903H6ZM12.5212 5.16913L12.8747 5.52269L12.8747 5.52269L12.5212 5.16913ZM13.3378 5.16913L12.9843 5.52269L12.9843 5.52269L13.3378 5.16913ZM14.831 6.66232L15.1846 6.30877V6.30877L14.831 6.66232ZM14.831 7.47897L14.4775 7.12542L14.831 7.47897ZM8.30984 13.5002H6V14.5002H8.30984V13.5002ZM6.5 14.0002V11.6903H5.5V14.0002H6.5ZM6.35355 12.0439L12.8747 5.52269L12.1676 4.81558L5.64645 11.3368L6.35355 12.0439ZM12.9843 5.52269L14.4775 7.01588L15.1846 6.30877L13.6914 4.81558L12.9843 5.52269ZM14.4775 7.12542L7.95629 13.6466L8.66339 14.3537L15.1846 7.83253L14.4775 7.12542ZM14.4775 7.01587C14.5077 7.04612 14.5077 7.09517 14.4775 7.12542L15.1846 7.83253C15.6054 7.41175 15.6054 6.72954 15.1846 6.30877L14.4775 7.01587ZM12.8747 5.52269C12.905 5.49244 12.954 5.49244 12.9843 5.52269L13.6914 4.81558C13.2706 4.39481 12.5884 4.39481 12.1676 4.81558L12.8747 5.52269Z"
                                fill="#31344E"
                              />
                              <path
                                d="M10.6196 7.0708L12.9295 9.38064"
                                stroke="#31344E"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z"
                                stroke="#31344E"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                        )}
                      </li>
                    );
                  })
                ) : (
                  <li>No {tagName ? tagName : ""} Found</li>
                )}
              </ul>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default SelectSectionCustom;
